export const Alert = ({ status, error_pct }) => {
  if (status === 'warning') {
    return (
      <div className="alert alert-danger alert-dismissible fade show" role="alert">
        The modeled lipid profile differs substantially ({error_pct}) from the target lipid profile!
        <hr></hr>
        <p className="mb-0">
          This can have many reasons, including
          <ul>
            <li>incomplete data</li>
            <li>unsuitable fatty acid set</li>
            <li>the optimization gets stuck in a local minima</li>
            <li>the biology of the lipid profile cannot be described stochastically</li>
          </ul>
        </p>
        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    )
  }
  return (
    <div className="alert alert-info alert-dismissible fade show" role="alert">
      The modeled lipid profile differs {error_pct} from the target lipid profile!
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  ) 
}
